/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!**************************************************!*\
  !*** ./src/assets/js/product-recommendations.js ***!
  \**************************************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

if (!customElements.get('product-recommendations')) {
  var Recommendations = /*#__PURE__*/function (_HTMLElement) {
    _inherits(Recommendations, _HTMLElement);

    var _super = _createSuper(Recommendations);

    function Recommendations() {
      var _this;

      _classCallCheck(this, Recommendations);

      _this = _super.call(this);
      var baseUrl = _this.dataset.baseUrl;
      var productId = _this.dataset.productId;
      var limit = _this.dataset.limit;
      var requestUrl = "".concat(baseUrl, "?section_id=product-recommendations&product_id=", productId, "&limit=", limit);

      if (productId) {
        fetch(requestUrl).then(function (response) {
          return response.text();
        }).then(function (data) {
          var container = document.createElement("div");
          container.innerHTML = data;
          var products = container.querySelectorAll(".shopify-section .product-recommendations-item");

          if (products) {
            _this.querySelector('.frequently-row-d').innerHTML = '';
            products.forEach(function (card) {
              card.querySelectorAll('script').forEach(function (el) {
                return el.remove();
              });

              _this.querySelector('.frequently-row-d').appendChild(card);
            });

            _this.removeAttribute('hidden');

            _this.setupSlider();

            window.dispatchEvent(new Event('scroll'));
          }
        })["catch"](console.log);
      }

      return _this;
    }

    _createClass(Recommendations, [{
      key: "setupSlider",
      value: function setupSlider() {
        var _Swiper;

        if (window.innerWidth <= 768) return;
        new Swiper(".recommendationSwiper", (_Swiper = {
          slidesPerView: 1.2,
          spaceBetween: 30,
          navigation: {
            nextEl: ".swiper-button-next-featured",
            prevEl: ".swiper-button-prev-featured"
          },
          scrollbar: {
            el: '.swiper-scrollbar-collection'
          },
          pagination: {
            el: '.swiper-dots-collection',
            type: 'bullets',
            clickable: true
          },
          loop: false,
          centerInsufficientSlides: true
        }, _defineProperty(_Swiper, "navigation", {
          nextEl: ".swiper-button-next-recommendations",
          prevEl: ".swiper-button-prev-recommendations"
        }), _defineProperty(_Swiper, "on", {// slideChange: function() {
          //   if (this.activeIndex === 0) {
          //     document.querySelector('.swiper-button-prev-recommendations').style.display = 'none';
          //   } else {
          //     document.querySelector('.swiper-button-prev-recommendations').style.display = 'flex';
          //   }
          //   let slides = (this.slides.length) - 1;
          //   if (this.activeIndex === slides) {
          //       document.querySelector('.swiper-button-next-recommendations').style.display = 'none';
          //   } else {
          //       document.querySelector('.swiper-button-next-recommendations').style.display = 'flex';
          //   }
          // }
        }), _defineProperty(_Swiper, "breakpoints", {
          0: {
            slidesPerView: 1.1,
            spaceBetween: 20
          },
          767: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          1024: {
            slidesPerView: 2.5,
            spaceBetween: 25
          },
          1280: {
            slidesPerView: 3.2,
            spaceBetween: 25
          },
          1650: {
            slidesPerView: 3.8,
            spaceBetween: 47
          }
        }), _Swiper));
      }
    }]);

    return Recommendations;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

  customElements.define('product-recommendations', Recommendations);
}
/******/ })()
;